<template>
  <div class="activity_list">
    <div v-if="!isPageError">
      <div class="head_tags">
        <div class="activity" @click="tagClick(0)" :class="{active:activeIndex === 0}">活动</div>
        <div class="match" :class="{active:activeIndex === 1}" @click="tagClick(1)">赛事</div>
      </div>
      <!-- 活动列表 -->
      <div class="list_container" v-if="activeIndex === 0">
        <div class="list">
          <van-list v-if="!isEmptyData" v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad" :immediate-check="false">
            <div slot="loading">
              <van-image class="loading_class" :width="45" :height="45" :src="require('../../assets/images/loading.gif')" />
            </div>
            <left-img :imageWidth="75" :imageHeight="100" :src="item.coverImg" @itemClick="toActivityDetail(item.id)" v-for="(item,index) in listData" :key="index">
              <template slot="right_container">
                <div class="item_right_container">
                  <div class="item_left">
                    <div class="list_title">{{item.name}}</div>
                    <div class="list_timeLine">
                      <div class="timeLine_date">{{item.isResident == 1?'全年':changeTime(item.activityStartTime,item.activityEndTime)}}</div>
                      <div class="timeLine_middle" v-if="item.isResident == 0">|</div>
                      <div class="timeLine_day" v-if="item.isResident == 0">{{computedDays(item.activityStartTime,item.activityEndTime)}}天</div>
                    </div>
                    <div class="item_location">
                      <div class="location_name">{{item.scenicName}}</div>
                      <div class="timeLine_middle" v-if="item.scenicName && isShowDistance">|</div>
                      <div class="location_distance" v-if="isShowDistance">{{distance(item.latitude,item.longitude)}}</div>
                    </div>
                    <div class="item_bottom">
                      <div class="item_fun" v-if="item.likeCount">{{item.likeCount}}人收藏</div>
                      <div class="item_charge" :style="{color:item.type == 2?'#2EBA73':'#FFAB48'}">{{item.type == 2?'':'门票'}}</div>
                    </div>
                  </div>
                </div>
                <div slot="item_right" class="item_right">
                  <!-- <div class="right_text">已结束</div> -->
                  <div class="right_text_before right_green" v-if="computeStatus(item,'活动') == '离开始状态'">
                    <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.activityStartTime).getTime())}}<span>天</span></div>
                    <div class="before_desc">离开始还有</div>
                  </div>
                  <div class="right_text_before right_green" :style="{color:'#2eba73'}" v-if="computeStatus(item,'活动') == '离结束状态'">
                    <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.activityEndTime).getTime())}}<span>天</span></div>
                    <div class="before_desc">离结束还有</div>
                  </div>
                  <div class="right_text_before" v-if="computeStatus(item,'活动') == '已结束'">
                    <div class="before_desc">已结束</div>
                  </div>
                  <div class="right_text_before right_green" :style="{color:'#2eba73'}" v-if="computeStatus(item,'活动') == '全年'">
                    <div class="before_desc">全年</div>
                  </div>
                </div>
              </template>
            </left-img>
          </van-list>
          <van-empty class="empty_container" v-else :image="require('../../assets/img/data_empty.png')" description="暂无活动内容" />

        </div>
      </div>

      <!-- 赛事列表 -->
      <div class="match_container" v-if="activeIndex === 1">
        <div class="list">
          <van-list v-if="!isEmptyData" v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad" :immediate-check="false">
            <div slot="loading">
              <van-image class="loading_class" :width="45" :height="45" :src="require('../../assets/images/loading.gif')" />
            </div>
            <left-img :imageWidth="75" :imageHeight="100" @itemClick="toMatchDetail(item.gid)" :src="item.point_pics" v-for="(item,index) in listData" :key="index">
              <template slot="right_container">
                <div class="item_right_container">
                  <div class="item_left">
                    <div class="left_top">
                      <div class="list_title">{{item.name}}</div>
                      <div class="list_timeLine">
                        <div class="timeLine_date">{{item.isResident == 1?'全年':changeTime(new Date(item.game_time).getTime(),new Date(item.end_time).getTime())}}</div>
                        <div class="timeLine_middle" v-if="item.game_time">|</div>
                        <div class="timeLine_day">{{computedDays(new Date(item.game_time).getTime(),new Date(item.end_time).getTime())}}天</div>
                      </div>
                    </div>
                    <div class="left_bottom">{{item.key}}</div>
                  </div>
                </div>
                <div slot="item_right" class="item_right">
                  <div class="right_text_before right_green" v-if="computeStatus(item,'赛事') == '离开始状态'">
                    <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.game_time).getTime())}}<span>天</span></div>
                    <div class="before_desc">离开始还有</div>
                  </div>
                  <div class="right_text_before right_green" v-if="computeStatus(item,'赛事') == '离结束状态'">
                    <div class="before_day">{{computedDays(new Date().getTime(),new Date(item.end_time).getTime())}}<span>天</span></div>
                    <div class="before_desc">离结束还有</div>
                  </div>
                  <div class="right_text_before" v-if="computeStatus(item,'赛事') == '已结束'">
                    <div class="before_desc">已结束</div>
                  </div>
                  <div class="right_text_before right_green" v-if="computeStatus(item,'赛事') == '全年'">
                    <div class="before_desc">全年</div>
                  </div>
                </div>
              </template>
            </left-img>
          </van-list>
          <van-empty v-else :image="require('../../assets/img/data_empty.png')" description="暂无赛事内容" />
        </div>
      </div>
    </div>
    <page-error v-else></page-error>
  </div>
</template>

<script>
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import { timestampToTimeForActivity, getDistance } from '../../common/common';
import axios from 'axios';
export default {
  name: "activity_list",
  data() {
    return {
      // tag 切换下标
      activeIndex: 0,
      pageIndex: 1,
      pageSize: 10,
      listData: [],
      isEmptyData: false,
      // 是否在加载中
      loading: true,
      // 是否已加载完成
      finished: false,
      isPageError: false,
      isShowDistance: false,
      finishedText: '',
    };
  },
  components: {
    LeftImg,
    PageError
  },
  mounted() {
    this.scenicId = this.$route.query.scenicId;
    this.getActivityData();
    this.isPageError = false;
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    // this.getMatchData();
  },
  watch: {
    finished: function (value) {
      console.log(value, 'finished');
      this.finishedText = value ? '没有更多了...' : '';
    }
  },
  methods: {

    /**
     * 计算状态
     */
    computeStatus(item, type) {
      if (item.isResident == 1) {
        return "全年";
      }
      let dayTime = new Date().getTime();  // 当前时间
      let endTime = '';
      let startTime = '';
      let msg = '';
      if (type == '赛事') {
        endTime = new Date(item.end_time).getTime();  // 结束时间
        startTime = new Date(item.game_time).getTime(); // 开始时间
        if (dayTime < startTime) {
          msg = "离开始状态";
        } else if (startTime < dayTime && dayTime < endTime) {
          msg = "离结束状态";
        } else {
          msg = "已结束";
        }
      } else { // 活动
        endTime = new Date(item.activityEndTime).getTime();  // 结束时间
        startTime = new Date(item.activityStartTime).getTime(); // 开始时间
        if (dayTime < startTime) {
          msg = "离开始状态";
        } else if (startTime < dayTime && dayTime < endTime) {
          msg = "离结束状态";
        } else {
          msg = "已结束";
        }
      }
      return msg;
    },

    /**
    * 计算距离你多少距离
    * @params lat lng 景区 景点 经纬度
    */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return obj.distance.toFixed(1) + (obj.type == 'km' ? 'km' : 'm');
      } else {
        // return { distance: '', text: '' };
        return '0m';
      }
    },

    /**
     * 跳转活动详情 
     */
    toActivityDetail(id) {
      console.log(id, '详情');
      this.$router.push({
        name: 'activityDetails',
        query: {
          id: id,
        },
      });
    },
    /**
     * 跳转赛事详情
     */
    toMatchDetail(id) {
      window.location.href = this.SHDetails + id;
    },
    /**
     * tag 切换
     */
    tagClick(num) {
      this.isEmptyData = false;
      this.loading = true;
      this.finished = false;
      if (num == 0) {
        this.pageIndex = 1;
        this.listData = [];
        this.getActivityData();
      } else {
        this.pageIndex = 1;
        this.listData = [];
        this.getMatchData();
        window.xm_bi.eventClick('click_activityEvent_game');
      }
      this.activeIndex = num;

    },
    /**
     * 获取我的活动列表
     */
    getActivityData() {
      this.$request.get(`/appserver/v1/activity/list?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&scenicId=${this.scenicId}`).then((res) => {
        if (res.data.ret == 0) {
          // 列表数据获取
          let resData = res.data.data;
          console.log(resData);
          if (resData) {
            let list = this.listData;
            this.listData = list.concat(resData);
          }
          // 数据为空
          if (this.pageIndex == 1 && (!resData || resData.length == 0)) {
            console.log('数据为空');
            this.loading = false;
            this.finished = true;
            this.isEmptyData = true;
          }
          // 数据已加载完毕
          if ((!resData || resData.length == 0) && this.listData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
        }
      }).catch((e) => {
        console.log(e);
        this.isPageError = true;
      });
    },
    /**
     * 获取我的赛事列表
     */
    getMatchData() {
      // let data = new FormData();
      // data.append('page', this.pageIndex);
      // data.append('page_size', this.pageSize);
      axios.create({
        baseURL: this.newUrlHost,
        headers: {},
        withCredentials: true,
      }).get(`/appserver/v1/game/gameList?page=${this.pageIndex}&page_size=${this.pageSize}`).then((res) => {
        if (res.data.ret == 0) {
          // 列表数据获取
          let resData = res.data.data;
          console.log(resData);


          if (resData) {
            // ios下 替换为/才会识别
            for (let i in resData) {
              resData[i].game_time = resData[i].game_time.replace(/(-)/g, '/');
              resData[i].end_time = resData[i].end_time.replace(/(-)/g, '/');
              resData[i].signup_end = resData[i].signup_end.replace(/(-)/g, '/');
              // console.log(this.listData[i].signup_end,'signup_end');
              // console.log(this.listData[i].end_time,'end_time');
              // console.log(this.listData[i].game_time,'game_time');
            }
            let list = this.listData;
            this.listData = list.concat(resData);
          }
          // 数据为空
          if (this.pageIndex == 1 && (!resData || resData.length == 0)) {
            console.log('数据为空');
            this.loading = false;
            this.finished = true;
            this.isEmptyData = true;
          }
          // 数据已加载完毕
          if ((!resData || resData.length == 0) && this.listData.length > 0) {
            console.log('数据已加载完毕');
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
        }
      }).catch((e) => {
        console.log(e);
        this.isPageError = true;
      });
    },

    onLoad() {
      this.pageIndex++;
      if (this.activeIndex == 0) {
        this.getActivityData();
      } else {
        this.getMatchData();
      }
    },

    /**
     * 列表需要的日期转换
     */
    changeTime(startTime, endTime) {
      // console.log(startTime, 'startTime')
      // console.log(endTime, 'endTime')
      if (endTime) {
        let start = timestampToTimeForActivity(startTime);
        let end = timestampToTimeForActivity(endTime);
        return start + '-' + end;
      } else {
        return timestampToTimeForActivity(new Date(startTime).getTime());
      }

    },
    /**
     * 计算天数
     */
    computedDays(startTime, endTime) {
      let utc = endTime - startTime;
      return Math.ceil(Math.abs(utc / (24 * 60 * 60 * 1000))); // 天
    }

  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.activity_list {
  .head_tags {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 12px 0px;
    font-size: 14px;
    color: #787878;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.06);
    .activity {
      margin-right: 30px;
    }
    .match,
    .activity {
      padding: 10px 12px;
      border-bottom: 4px solid white;
    }
    .active {
      color: #2eba73;
      border-bottom: 4px solid #2eba73;
    }
  }
  .list_container {
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 10px;
    .list_topInfo {
      display: flex;
      background: rgba(143, 117, 255, 0.3);
      border-radius: 3px;
      padding: 5px 10px;
      color: #4f2ec4;
      justify-content: space-between;
      align-items: center;
      .topInfo_title {
        font-size: 14px;
        font-weight: bold;
      }
      .topInfo_right {
        font-size: 12px;
        display: flex;
        .topInfo_middle {
          margin: 0 3px;
        }
      }
    }
    .list {
      margin-top: 20px;
      .item_right_container {
        // width: 100%;
        width: calc(100% - 88px - 75px);
        display: flex;
        justify-content: space-between;
        .item_left {
          margin-left: 10px;

          .list_title {
            font-size: 16px;
            color: #262626;
            font-weight: bold;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .list_timeLine {
            display: flex;
            color: #787878;
            font-size: 12px;
            display: flex;
            // justify-content: center;
            align-items: center;
            margin-top: 6px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_location {
            display: flex;
            font-size: 12px;
            color: #787878;
            margin-top: 5px;
            .timeLine_middle {
              margin: 0 3px;
            }
          }
          .item_bottom {
            margin-top: 6px;
            display: flex;
            font-size: 12px;
            color: #787878;
          }
          .item_charge {
            margin-left: 3px;
            color: #2eba73;
          }
        }
      }
      .item_right {
        margin-left: auto;
        width: 88px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        .right_text {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.5);
        }
        .right_text_before {
          .before_day {
            font-size: 34px;
            color: #000000;
            text-align: center;
            font-family: DINCond-Bold, DINCond;
            font-weight: bold;
            span {
              font-size: 14px;
              margin-left: 1px;
              font-weight: 400;
            }
          }
          .before_desc {
            text-align: center;
            color: #787878;
            font-size: 11px;
          }
        }
        .right_green {
          color: #2eba73 !important;
          .before_day {
            font-size: 34px;
            color: #2eba73;
            span {
              font-size: 14px;
              margin-left: 1px;
            }
          }
          .before_desc {
            color: #2eba73;
            font-size: 11px;
          }
        }
      }
    }
  }
}
.match_container {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 10px;
  box-sizing: border-box;
  .list {
    margin-top: 20px;
    .item_right_container {
      display: flex;
      justify-content: space-between;
      width: calc(100% - 88px - 75px);
      .item_left {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .left_bottom {
          color: #2eba73;
          font-size: 12px;
        }
        .list_title {
          font-size: 16px;
          color: #262626;
          font-weight: bold;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .list_timeLine {
          display: flex;
          color: #787878;
          font-size: 12px;
          display: flex;
          // justify-content: center;
          align-items: center;
          margin-top: 6px;
          .timeLine_middle {
            margin: 0 3px;
          }
        }
      }
    }
    .item_right {
      margin-left: auto;
      width: 88px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      .right_text {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.5);
      }
      .right_text_before {
        .before_day {
          font-size: 34px;
          color: #000000;
          span {
            font-size: 14px;
            margin-left: 1px;
          }
        }
        .before_desc {
          color: #787878;
          font-size: 11px;
        }
      }
      .right_green {
        color: #2eba73 !important;
        .before_day {
          font-size: 34px;
          color: #2eba73;
          span {
            font-size: 14px;
            margin-left: 1px;
          }
        }
        .before_desc {
          color: #2eba73;
          font-size: 11px;
        }
      }
    }
  }
  .loading_class {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .van-empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
/deep/.van-empty__image {
  width: 245px;
  height: 170px;
}
</style>
